import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { FormTextField } from '../../common/Form/FormTextField';
import { FormRichTextEditor } from '../../common/Form/FormRichTextEditor';

function EditSummaryBody({
  isLoading,
  isReady,
  title,
  onTitleChange,
  editorContent,
  onEditorChange,
}) {
  if (isLoading || !isReady) {
    return (
      <>
        <Skeleton variant="text" width={80} height={24} />
        <Skeleton variant="rectangular" height={40} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={200} />
      </>
    );
  }

  return (
    <>
      <Box className="titleField">
        <FormTextField
          id="editSummary__field_title"
          label="Title"
          ariaLabel="Summary Note Title"
          value={title}
          onChange={(event) => onTitleChange(event.target.value)}
          fullWidth
        />
      </Box>

      <Box className="contentField" id="editSummary__box_editor">
        <FormRichTextEditor value={editorContent} onChange={onEditorChange} />
      </Box>
    </>
  );
}

export default EditSummaryBody;
